let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("7Q0UC"), load("4PQXU"), load("5joXW"), load("c6MKV"), load("6ZgMI"), load("1epse"), load("6H998")]).then(() => parcelRequire('bbp2J'));